import { stringify } from '@backmarket/utils/query-string/stringify'
import { urlHashToObject } from '@backmarket/utils/url/urlHashToObject'

// Namespaced so it can't collide with the many other scopes that already
// read/write their own hash params on shared pages (product-list filters,
// reviews filters, table of contents, etc.) — the hash is a global
// namespace, unlike a scope-owned query param.
export const HASH_MESSAGE_KEY = 'assistant_message'
export const HASH_MESSAGE_SOURCE_KEY = 'assistant_message_source'
// Bare trigger key: opening the assistant with no seeded message. Same
// namespace convention as the seeded-message keys (see HASH_MESSAGE_KEY).
export const HASH_OPEN_KEY = 'assistant_open'

// Strips only the shopping-assistant hash keys, preserving any other scope's
// hash params that happen to share the same URL fragment (the hash is a
// shared namespace — see HASH_MESSAGE_KEY above). Covers both the seeded
// message and the bare open trigger, since they may ride along together
// (e.g. #assistant_open&assistant_message=…).
export function removeSeededMessageFromHash(hash: string): string {
  const values = urlHashToObject(hash)
  delete values[HASH_MESSAGE_KEY]
  delete values[HASH_MESSAGE_SOURCE_KEY]
  delete values[HASH_OPEN_KEY]

  const remaining = stringify(values)

  return remaining ? `#${remaining}` : ''
}
